import type { FaireProductEntity } from "../../entity_types/product";

export const p_75yckby8xb: FaireProductEntity = {
  token: "p_75yckby8xb",
  type: "product",
  name: "Genmaicha Green",
  brandToken: "b_6su5v1sirt",
  brandName: "Highwire Coffee Roasters",
  imageUrl: "https://cdn.faire.com/fastly/6926ad753700075d71a7af9cee88ae8a2258f3a9cd04cc8e11b2f85da979ccd0.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7bd87521481fd1c94213fcdc359463bc684f5b375a74f6827973e40e72901964.jpeg",
    "https://cdn.faire.com/fastly/76f5eed413df96f8ae7083d3d57247800566ac30b296447dfd2b9a6efccc7499.png"
  ],
  priceDollars: 10.5,
  description: "\nProfile: Classic, comforting, toasty. A traditional tea made with roasted brown rice and Japanese green tea. We chose a high-grade Genmaicha, even for a tea with such humble origins, as we believe it makes a difference that you can taste.\n\n\n\n\n\nProfile: Classic, comforting, toasty\n\n\n\nA traditional tea made with roasted brown rice and Japanese green tea. We typically brew it similar to a black tea with hotter water and a short steep time as this brings out the full nutty flavor of the rice. We choose a high-grade Genmaicha, even for a tea with such humble origins, as we believe it makes a difference that you can taste. \n\n\n\nWe recommend brewing 1g of tea in 2oz of water at 210° for 1.5 minutes.\n\n\n",
  tags: [],
  msrpDollars: 15,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-08T20:57:43.161Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
